import {
  DeliverableAnalyticScreenshotOverrideAction,
  DeliverableUploadedAction,
  UserAction
} from 'modules/tracking/types/user-actions';

export const isDeliverableAnalyticScreenshotOverrideAction = (
  action?: UserAction
): action is DeliverableAnalyticScreenshotOverrideAction => (
  action !== undefined
  && action.eventCategory === 'deliverable'
  && action.eventAction === 'analytic-screenshot-override'
);

export const isDeliverableUploadedActionAction = (
  action?: UserAction
): action is DeliverableUploadedAction => (
  action !== undefined
  && action.eventCategory === 'deliverable'
  && [
    'content for approval',
    'caption for approval',
    'post high-res image',
    'post url',
    'post analytics screenshot',
    'reel high-res snippet',
    'reel url',
    'reel analytics screenshot',
    'story snippet',
    'story analytics screenshot',
    'tiktok video url',
    'tiktok analytics screenshot',
    'tiktok video',
    'other url',
    'other files',
    'blog url',
    'youtube video url'
  ].indexOf(action.eventAction) > -1
);
